<div class="header col-sm-12" id="headerMsg">
  <div class="col-sm-8">
    <h2 style="margin: 0;"> Discussion du bon {{ row.bon ? row.bon.numBon : '' }} </h2>
  </div>
  <div class="col-sm-4 text-right">
    <button class="uppercase btn-header" id="close3" (click)="closeFct()">
      Fermer
    </button>
  </div>
</div>

<div class="col-sm-12 p-0 listeMvt" style="    height: auto;display: flex;" id="prestation" *ngIf="!depuisPlanning">
  <ngx-datatable #myTable class="material" [rows]="mouvementsRows" [columnMode]="'force'" [headerHeight]="50"
    [footerHeight]="0" [rowHeight]="'auto'" [selectionType]="'checkbox'">


    <ngx-datatable-column name="DateDebut" prop="dateFilter" [width]="100">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase">Date</span>
          <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div class="strong">{{row.dateDebut}}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Client" prop="client.nomClient">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase">Client</span>
          <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div class="strong"> {{value}} </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Chantier" prop="chantier.libelleObjetEntite" [width]="260">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase">Chantier</span>
          <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true" (click)="sort()"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true" (click)="sort()"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div class="strong"> {{value}} </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Bon" prop="bon.numBon">
      <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
        let-selectFn="selectFn" let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase">N°</span>
          <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div class="strong"> {{value}} </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Article" prop="article.libelle">
      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
        let-sort="sortFn">
        <div class="tableheader" (click)="sort()">
          <span class="uppercase">Prestation</span>
          <div class=" col-sm-1 pull-right">
            <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
            <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div class="strong"> {{value}} </div>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>
</div>
<div class="col-sm-12" style="padding: 0px;"
  [ngStyle]="{'height': !depuisPlanning ? getHeight() : 'calc(100% - 46px)'}">
  <div class="app">
    <div class="row app-one">
      <div class="col-sm-12 conversation">
        <!-- Message Box -->
        <div class="row message" id="conversation" style="display: flex;">
          <div class="parentMessage">
            <div class="row" *ngFor="let date of filterDate(listDate)">
              <div class="text-center">
                <div class="dateMessage"> {{ date }}</div>
              </div>
              <div class="row message-body" *ngFor="let msg of filterBy(listMessageBon[date], 'time')">
                <div class="col-sm-12"
                  [ngClass]="{'message-main-receiver': (msg.clefUser) !== (''+user.id), 'message-main-sender': (msg.clefUser) === (user.id)}">
                  <div class=""
                    [ngClass]="{'receiver': (msg.clefUser) !== (user.id), 'sender': (msg.clefUser) === (user.id)}">
                    <label> {{msg.nom || (user.nom || '')}} </label>
                    <div class="message-text" *ngIf="!msg.isFile" [innerHTML]="msg.message">
                    </div>
                    <div class="message-text" *ngIf="msg.isFile && !msg.image">
                      <a class="row" [href]="msg.content | safe" download="{{msg.nomFichier}}"
                        style="color: inherit !important;">
                        <div class="col-sm-2">
                          <i class="fa fa-file-o fa-2x" aria-hidden="true"></i>
                        </div>
                        <div class="col-sm-10"> {{msg.nomFichier}} </div>
                      </a>
                    </div>
                    <div class="message-text" *ngIf="msg.isFile && msg.image">
                      <a [href]="msg.content | safe" download="{{msg.nomFichier}}"><img [src]="msg.content | safe"></a>
                    </div>
                    <span class="message-time pull-right">
                      {{ msg.heure }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row reply">
          <div class="col-sm-10 col-xs-10 reply-main">
            <textarea class="form-control" rows="1" id="comment"></textarea>
          </div>

          <!--
          <div class="col-sm-1 col-xs-1 reply-recording">
            <label for="exampleFormControlFile1">
              <i class="fa fa-paperclip fa-2x" aria-hidden="true" style="transform: rotate(90deg);"></i>
            </label>
            <input type="file" class="form-control-file" style="display: none;" id="exampleFormControlFile1"
              (change)="getNameFile($event)"  accept="{{ common.extFichierImgEtTexte }}" >
          </div>
          -->

          <div class="col-sm-1 col-xs-1 reply-send">
            <i class="fa fa-send fa-2x" aria-hidden="true" (click)="envoieMessage()"></i>
          </div>
        </div>
      </div>
      <!-- Conversation End -->
    </div>
    <!-- App One End -->
  </div>
</div>

<ng-template #msgPopup>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="errorPopup"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer </button>
    </div>
  </div>
</ng-template>